import React, { useContext, useRef } from 'react';

import PropTypes from 'prop-types';
import {
  Onboarding,
  OnboardingContext,
  OnboardingSubtitle,
  OnboardingTitle,
} from 'registration/containers/Onboarding';

import { Input } from 'shared/components/ihcl/input';
import { Center } from 'shared/components/ihcl/positioning';

const OnboardingPassword = ({
  nextAction = null,
  previousAction = null,
  stepNumber,
}) => {
  const { onboardingData, setOnboardingData } = useContext(OnboardingContext);
  const nextActionButtonRef = useRef(null);
  if (!onboardingData || Object.keys(onboardingData).length < 1) {
    return null;
  }
  const { errors, password } = onboardingData;

  let passwordError = null;
  if (errors && errors.password && Array.isArray(errors.password)) {
    passwordError = errors.password.join('; ');
  }
  if (
    errors &&
    errors['user.password'] &&
    Array.isArray(errors['user.password'])
  ) {
    passwordError = errors['user.password'].join('; ');
  }

  const setPassword = (passwordStr, errorMessage) => {
    let newErrors = null;
    if (errorMessage) {
      newErrors = {
        ...errors,
        password: errorMessage,
      };
    } else if (errors) {
      newErrors = Object.fromEntries(
        Object.entries(errors).filter(([key]) => key !== 'password')
      );
    }
    const newOnboardingData = {
      ...onboardingData,
      password: passwordStr,
    };
    if (newErrors) {
      newOnboardingData.errors = newErrors;
    }
    setOnboardingData(newOnboardingData);
  };

  return (
    <Onboarding
      currentStep={stepNumber}
      isNextDisabled={!password}
      nextAction={nextAction}
      nextActionButtonRef={nextActionButtonRef}
      previousAction={previousAction}
      stepKeys={['password']}
      stepName="Password"
    >
      <Center>
        <OnboardingTitle>Create your password</OnboardingTitle>
        <Center>
          <OnboardingSubtitle>
            We care about your career -- but first, we care about your security
          </OnboardingSubtitle>
          <form
            action="#"
            onSubmit={(evt) => {
              evt.preventDefault();
              if (
                !passwordError &&
                nextActionButtonRef &&
                nextActionButtonRef.current
              ) {
                nextActionButtonRef.current.click();
              }
            }}
          >
            <Input
              value={password}
              type="password"
              label="Type your password"
              onChange={(evt) => {
                setPassword(evt.target.value, null);
              }}
              onBlur={(evt) => {
                if (!evt.target.value) {
                  setPassword(evt.target.value, 'Please enter a password');
                }
              }}
              error={!!passwordError}
              caption={passwordError}
            />
          </form>
        </Center>
      </Center>
    </Onboarding>
  );
};
OnboardingPassword.propTypes = {
  nextAction: PropTypes.string,
  previousAction: PropTypes.string,
  stepNumber: PropTypes.number.isRequired,
};

export default OnboardingPassword;
